export const comorbidConditions = [
  'Myocardial Infarction',
  'Congestive Heart Failure',
  'Peripheral Vascular Disease',
  'Cerebrovascular Disease',
  'Dementia',
  'COPD',
  'Connective Tissue Disorder',
  'Peptic Ulcer Disease',
  'Diabetes with end organ damage',
  'Diabetes without end organ damage',
  'Chronic Kidney Disease - moderate to severe',
  'Hemiplegia',
  'Leukaemia',
  'Solid Tumour',
  'Solid Tumour Metastatic',
  'Liver Disease - mild',
  'Liver Disease - moderate to severe',
  'AIDS'
  // 'Venous Thrombosis',
  // 'Hypertension',
  // 'GORD',
  // 'Osteoporosis',
  // 'Depression and / or Anxiety',
  // 'Chronic Pain Syndrome or Fibromyalgia',
  // 'Haematological diagnosis',
  // 'Skin rashes',
  // 'Inflammatory Arthritis'
]

export const languages = [
  'Bengali',
  'Chinese',
  'Dutch',
  'English',
  'French',
  'German',
  'Greek',
  'Hindi',
  'Italian',
  'Japanese',
  'Korean',
  'Lebanese',
  'Portuguese',
  'Spanish',
  'Vietnamese'
];

export const planCodes = [
  'A1 - Ready for surgery',
  'A2 - Surgery probable',
  'A3 - Surgery opinion',
  'A4 - Arthroscopy',
  'B1 - Conservative therapy, not ready',
  'B2 - Too unwell',
  'B3 - Refusal surgery',
  'C - Non OA',
  'Other'
]

export const walkingDistances = [
  'Less than 50 metres',
  '50-100 metres',
  '100-500 metres',
  '500-1000 metres',
  'Unlimited'
]
